import {Component} from 'react';
import h from 'react-hyperscript';
import {caption} from 'Components/Typography/Typography';
import {RESOURCE} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';

class ListItem extends Component {
  createChildren() {
    if (this.props.item.resource_link) {
      const href = this.props.item.resource_link;

      return (
        h('a', {
          href,
          target: '_blank',
          onClick: () => {
            pushGTMEvent(RESOURCE.TAG, {
              event: RESOURCE.EVENT,
              action: {resource_action: RESOURCE.ACTION.RESOURCE_CLICK},
              variables: {
                resource_category:
                  this.props.resourceCategory ?
                    this.props.resourceCategory : 'Classroom Activity',
                resource_url: href,
              },
            });
          },
        }, h(caption, {
          className: 'cta text--blue',
        }, `${this.props.index + 1}. ${this.props.item.resource_name}`))
      );
    } else {
      return (
        h(caption, {
          className: 'text--grey',
        }, `${this.props.index + 1}. ${this.props.item}`)
      );
    }
  }

  render() {
    return (
      h('li', {
        className: 'padding-bottom--micro',
      }, this.createChildren())
    );
  }
}

export default ListItem;
